import { DEFAULT_INVOICE_PART_TITLES, INVOICE_PARTS, type InvoiceData, type InvoiceItem } from "@shared/invoice";
import type { QuoteData } from "./pdf-generator";
import { offerPart } from "./offer-parts";

/** A detached snapshot, never a live link to editable offer/photo positions. */
export function invoiceFromQuote(quote: QuoteData, invoiceDate: string): InvoiceData {
  const items: InvoiceItem[] = quote.items.map((item, index) => ({
    id: `offer-${index}`,
    description: item.beschreibung?.trim() || item.description,
    quantity: item.quantity,
    unit: item.unit,
    unitPrice: item.unitPrice,
    billable: !item.variant,
    teil: offerPart(item.teil),
    ...(item.sourceLabel ? { sourceLabel: item.sourceLabel } : {}),
  }));
  quote.perPhoto?.forEach((photo, photoIndex) => {
    photo.positions.forEach((position, index) => {
      items.push({
        id: `photo-${photoIndex}-${index}`,
        description: position.beschreibung?.trim() || position.name,
        quantity: position.qty,
        unit: position.unit,
        unitPrice: position.ep,
        billable: !position.variant,
        teil: offerPart(position.teil),
        sourceLabel: `${photo.photoLabel}${photo.fileName ? ` · ${photo.fileName}` : ""}`,
      });
    });
  });
  return {
    projectName: quote.projectName,
    customerName: quote.customerName,
    customerAddress: quote.customerAddress,
    customerUid: "",
    sellerUid: "",
    invoiceNumber: "",
    invoiceDate,
    dueDate: "",
    servicePeriod: "",
    sourceQuoteNumber: quote.quoteNumber ?? "",
    notes: quote.notes,
    paymentTerms: "",
    taxRate: 20,
    groupByPart: items.some((item) => item.teil !== "A"),
    partTitles: Object.fromEntries(INVOICE_PARTS.map((part) => [
      part, quote.offerParts?.[part]?.title?.trim() || DEFAULT_INVOICE_PART_TITLES[part],
    ])) as NonNullable<InvoiceData["partTitles"]>,
    items,
  };
}
